module.exports = "<unauthenticated-layout>\n    <h1>Oops!  An unexpected error occurred.</h1>\n</unauthenticated-layout>";